import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { ReceiverService } from '../../../services/receiver.service';
import { emptyReceiverList, IReceiverList } from '../../../model/receiver-list';
import { emptyPlatform, IPlatform } from '../../../model/platform';
import { PlatformService } from '../../../services/platform.service';
import { IReceiver } from '../../../model/receiver';
import { emptyReceiverFilter, IReceiverFilter } from '../../../model/receiver-filter';
import { Subject } from 'rxjs/Subject';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params } from "@angular/router";

@Component({
  selector: 'app-inv-receiver-list',
  templateUrl: './inv-receiver-list.component.html',
  styleUrls: ['./inv-receiver-list.component.css']
})
export class InvReceiverListComponent implements OnInit, OnDestroy {

  receiverList: IReceiverList = emptyReceiverList;
  /**
   * Identificador de Invoicing Service
   */
  identifier: string;

  /**
   *
   * @type {IPlatform[]}
   */
  platforms: IPlatform[] = [];

  /**
   * Filter of receivers
   * @type {IReceiverFilter}
   */
  filter: IReceiverFilter = emptyReceiverFilter;

  /**
   *
   * @type {Subject<any>}
   */
  subject: Subject<string> = new Subject();

  /**
   *
   * @type {number}
   */
  itemsPerPage: number = 5;

  /**
   *
   * @type {number}
   */
  p: number = 0;

  /**
   * Contenido del panel modal para actualizar un receiver
   */
  @ViewChild('updatePlatformReceiver')
  updatePlatformReceiver: TemplateRef<any>;

  /**
   * Contenido del panel modal para actualizar un receiver
   */
  @ViewChild('updateReceiver')
  updateReceiver: TemplateRef<any>;

  /**
   * Contenido del panel modal para actualizar un receiver
   */
  @ViewChild('viewUpdateSelectedReceivers')
  viewUpdateSelectedReceivers: TemplateRef<any>;

  /**
   * Indica si se selecciona o no todos los elementos
   * @type {boolean}
   */
  swSelectAll: boolean = false;

  /**
   * Receiver seleccionado
   * @type {IReceiver}
   */
  selectedReceiver: IReceiver = null;

  /**
   * Sw indicating whether button activate is selected or not
   * @type {boolean}
   */
  swActivateSelectedReceivers: boolean = true;

  /**
   *
   * @param {LoginService} loginService
   * @param {ReceiverService} receiverService
   * @param {PlatformService} platformService
   * @param {ToastsManager} toastr
   * @param {TranslateService} translate
   * @param {NgbModal} modalService
   * @param {ActivatedRoute} route
   */
  constructor(private loginService: LoginService,
              private receiverService: ReceiverService,
              private platformService: PlatformService,
              private toastr: ToastsManager,
              private translate: TranslateService,
              private modalService: NgbModal,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params
      .subscribe((params: Params) => {
        this.identifier = params['identifier'];
        this.getInvoicingServiceReceivers();
        this.platformService.getPlatforms(this.identifier)
          .subscribe(res => this.platforms = res);
      });
    this.subject.debounceTime(400).subscribe(() => {
      this.getInvoicingServiceReceivers();
    });
  }

  ngOnDestroy() {
    this.clearFilter();
  }

  getInvoicingServiceReceivers() {
    this.receiverService.getInvoicingServiceReceivers(this.identifier, this.filter)
      .subscribe(res => {
        this.receiverList = res as IReceiverList;
      });
  }

  /**
   *
   * @param {IPlatform} platformOne
   * @param {IPlatform} platformTwo
   * @return {boolean}
   */
  compareFn(platformOne: IPlatform, platformTwo: IPlatform): boolean {
    return (platformOne && platformTwo) && (platformOne.id === platformTwo.id);
  }


  /**
   *
   * @param {IPlatform} platform
   * @param {IReceiver} receiver
   */
  onChangePlatform(platform: IPlatform, receiver: IReceiver){
    this.modalService.open(this.updatePlatformReceiver).result.then((result) => {
      if (result === 'update') {
        let oldPlatform = receiver.platform;
        receiver.platformId = platform.id;
        this.receiverService.updateInvoicingServiceReceiver(oldPlatform, receiver, this.identifier)
          .subscribe(res => {
            this.receiverList.items[this.receiverList.items.findIndex(item => item.id == res.id)] = res;
          });
      }
    })
  }


  /**
   * Abre el panel modal para actualizar un receiver
   */
  onUpdateReceiverStatusClicked(receiver: IReceiver) {
    this.selectedReceiver = receiver;
    this.modalService.open(this.updateReceiver).result.then((result) => {
      if (result === 'update') {
        let previousStatus = receiver.status;
        let newStatus = receiver.status === 'A' ? 'C' : (receiver.status === 'CI' || receiver.status === 'CC' ? 'A' : null);
        this.updateInvoicingServiceReceiver(receiver, previousStatus, newStatus);
      }
    });
  }

  /**
   * Update the receiver state
   * @param {IReceiver} receiver
   */
  updateInvoicingServiceReceiver(receiver: IReceiver, previousStatus: string, newStatus: string): void {
    receiver.status = newStatus;
    this.receiverService.updateInvoicingServiceReceiver(receiver.platform, receiver, this.identifier)
      .subscribe(res => {
          this.selectedReceiver = null;
          this.swSelectAll = false;
          this.receiverList.items[this.receiverList.items.findIndex(item => item.id == res.id)] = res;
        },
        error => {
          this.selectedReceiver = null;
          receiver.status = previousStatus;
          this.translate.get(error).subscribe((res: string) => {
            this.toastr.warning(res).then();
          });
        });
  }

  /**
   *
   * @param {IReceiver} receiver
   */
  getStatusTitle(receiver: IReceiver): string {
    let status;
    receiver.status === 'A' ? status = 'Desactivar' : status = 'Activar';
    return status;
  }

  onKeyUp() {
    this.subject.next();
  }

  clearFilter() {
    this.filter.direName = '';
  }

  /**
   *
   * @return {boolean | IReceiver[]}
   */
  isDataSelected() {
    return this.getSelectedReceivers().length > 0;
  }

  /**
   *
   * @return {IReceiver[]}
   */
  getSelectedReceivers(): IReceiver[] {
    return this.receiverList.items
      .filter(res => {
        return res.selected === true;
      }).map(res => {
        return {
          id: res.id,
          dire: res.dire,
          platform: res.platform,
          platformId: res.platformId,
          status: res.status,
          direCode: res.dire.code,
          selected: res.selected
        };
      });
  }

  /**
   * Select/Deselect all receivers
   */
  onSelectAllClicked(): void {
    this.selectedReceiver = null;
    for (let receiver of this.receiverList.items) {
      if (receiver.status != 'CC') {
        receiver.selected = !this.swSelectAll;
      }
    }
  }

  /**
   * Activate the selected receivers
   */
  onActivateReceiversClicked() {
    this.swActivateSelectedReceivers = true;
    this.updateSelectedReceivers(this.getSelectedReceivers(), 'CI', 'A');
  }

  /**
   * Desactivate the selected receivers
   */
  onDesactivateReceiversClicked() {
    this.swActivateSelectedReceivers = false;
    this.updateSelectedReceivers(this.getSelectedReceivers(), 'A', 'C');
  }


  /**
   *
   * @param {IReceiver[]} selectedReceiver
   * @param previousStatus
   * @param newStatus
   */
  updateSelectedReceivers(selectedReceiver: IReceiver[], previousStatus: string, newStatus: string) {
    if (selectedReceiver && selectedReceiver.length != 0) {
      this.modalService.open(this.viewUpdateSelectedReceivers).result.then((result) => {
        if (result === 'update') {
          for (let receiver of selectedReceiver) {
            if (receiver.status == previousStatus) {
              this.updateInvoicingServiceReceiver(receiver, previousStatus, newStatus);
            }
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-receiver-list/inv-receiver-list.component.ts